<div class="footer_links">
    <p><a href="https://www.nbcuniversal.com/privacy" target="_blank">NBCU Privacy Policy</a></p>    
    <p><a href="https://www.chasepaymentech.com/privacypolicy" target="_blank">Chase Privacy Policy</a></p>         
    <p><a href="../../assets/MediaPay_Terms.pdf" target="_blank">Terms of Service</a></p>
</div>